import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { useSelector } from 'react-redux';
import Loader from '../../../components/common/Loader';

import './Audience.css';
import PieChart from '../../../components/custom/PieChart';

const DemographicCard = ({ xx, isBigScreen, genderRatios, generationRatios, locationRatios, Purchasing }) => {
    const loadingGender = useSelector(state => state.audienceGender.loading);
    const loadingGeneration = useSelector(state => state.audienceGeneration.loading);
    const loadingLocation = useSelector(state => state.audienceLocations.loading);
    const loadingPurchasing = useSelector(state => state.audiencePurchasing.loading);

    const isLoading = loadingGender || loadingGeneration || loadingLocation || loadingPurchasing;

    const nivoPieData = (ratios, labelKey) => {
        if (xx && Array.isArray(ratios)) {
            return ratios.map(item => ({
                id: item[labelKey],
                label: item[labelKey],
                value: item.ratio,
            }));
        }
        return [{ id: 'No Data', label: 'No Data', value: 100 }];
    };
    const transformGenderRatios = (genderRatios) => {
        return [
            { gender: "Female", ratio: genderRatios.femaleRatio },
            { gender: "Male", ratio: genderRatios.maleRatio }
        ];
    };

    const transformGenerationRatios = (generationRatios) => {
        return [
            { generation: "Alpha", ratio: generationRatios.alphaRatio },
            { generation: "Baby Boomer", ratio: generationRatios.babyBoomerRatio },
            { generation: "Generation X", ratio: generationRatios.xratio },
            { generation: "Millennials (Y)", ratio: generationRatios.yratio },
            { generation: "Generation Z", ratio: generationRatios.zratio }
        ];
    };

    const transformPurchasingData = (purchasingData) => {
        if (Object.keys(purchasingData).length == 0) {
            return [{ purchasingPower: "No Data", ratio: 100 }];
        }
        return [
            { purchasingPower: "Very High", ratio: purchasingData.veryHighRatio },
            { purchasingPower: "High", ratio: purchasingData.highRatio },
            { purchasingPower: "Moderate", ratio: purchasingData.moderateRatio },
            { purchasingPower: "Low", ratio: purchasingData.lowRatio },
            { purchasingPower: "Very Low", ratio: purchasingData.veryLowRatio }
        ];
    };

    const genderPieData = xx ? nivoPieData(transformGenderRatios(genderRatios), 'gender') : [{ id: 'No Data', label: 'No Data', value: 100 }];
    const generationPieData = xx ? nivoPieData(transformGenerationRatios(generationRatios), 'generation') : [{ id: 'No Data', label: 'No Data', value: 100 }];
    const locationPieData = xx ? nivoPieData(locationRatios, 'name') : [{ id: 'No Data', label: 'No Data', value: 100 }];
    const purchasingPieData = xx ? nivoPieData(transformPurchasingData(Purchasing), 'purchasingPower') : [{ id: 'No Data', label: 'No Data', value: 100 }];

    return (
        <Card className="demographic-card">
            <CardHeader className="demographic-card-header">
                <h4 className="card-title">
                    <b>Demographic Segmentation</b>
                </h4>
            </CardHeader>
            {
                isLoading ? (
                    <CardBody  className="demographic-card-body" style={{ height: '230px' }} >
                        <Loader />
                    </CardBody>

                ) : (
                    <CardBody className="demographic-card-body">
                        <div className="pie-chart-container">
                            <PieChart data={genderPieData} title="Gender Ratio" />
                            <PieChart data={generationPieData} title="Generation Ratio" />
                            <PieChart data={locationPieData} title="Location Ratio" />
                            <PieChart data={purchasingPieData} title="Purchasing Power" />
                        </div>
                    </CardBody>
                )
            }
        </Card>
    );
};

export default DemographicCard;
